import {
  DSR_TEMPLATE_SAVE,
  DSR_TEMPLATE_RESET,
  DSR_TEMPLATE_REMOVE,
} from 'src/actions/constants';
import { columnLabels } from './DsrTemplate.helper';

const initialState = {
  blColumns: {},
  containerColumns: {},
  shipmentColumns: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DSR_TEMPLATE_SAVE: {
      const { headerOrder, items, header } = action;
      return {
        ...state,
        [headerOrder]: {
          ...state[headerOrder],
          [header]: items,
        },
      };
    }
    case DSR_TEMPLATE_RESET: {
      return initialState;
    }
    case DSR_TEMPLATE_REMOVE: {
      const {
        item,
        header,
      } = action;
      const { headerOrder } = item;
      return {
        ...state,
        [headerOrder]: {
          ...state[headerOrder],
          [header]: state[headerOrder][header]?.filter(column => column.key !== item.key),
        },
      };
    }
    default: return state;
  }
}
